<div class="heading" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <mode-dialog-header>
    <h1 heading>Table calculation settings</h1>
  </mode-dialog-header>
</div>
<div class="content-container">
  <!--
    Quick Calc selection (optional)
    -->
  <mode-labeled-menu
    *ngIf="quickCalc"
    label="Quick table calculation type"
    [selected]="quickCalc"
    [menuItems]="quickCalcOptions"
    (menuChange)="onChangeQuickCalc($event)"
  ></mode-labeled-menu>
  <!--
    Relative to selection (optional)
    -->
  <mode-labeled-menu
    *ngIf="relativeTo"
    label="Relative to"
    [selected]="relativeTo"
    [menuItems]="relativeToOptions"
    (menuChange)="onChangeRelTo($event)"
  ></mode-labeled-menu>
  <!--
    Total using selection (optional)
    -->
  <mode-labeled-menu
    *ngIf="totalUsing"
    label="Total using"
    [selected]="totalUsing"
    [menuItems]="totalUsingOptions"
    (menuChange)="onChangeTotalUsing($event)"
  ></mode-labeled-menu>
  <!--
    Frame selection (required)
    -->
  <mode-labeled-menu
    label="Calculate using"
    [selected]="frameType"
    [menuItems]="frameTypeOptions"
    (menuChange)="onChangeFrameType($event)"
  ></mode-labeled-menu>
  <!--
    Addressing/Partitioning sets
    -->
  <label class="form-control-label">Apply calculation in the following order</label>
  <div class="sd-container">
    <div class="sd-label">Addressing</div>
    <div
      class="sd-fields"
      [class.empty]="!(addrFields.length || outOfScopeAddrFields.length)"
      (dndDrop)="onDrop($event.index, addrFields, true)"
      dndEffectAllowed="move"
      dndDropzone
    >
      <div class="sd-field-placeholder" dndPlaceholderRef></div>
      <div
        class="sd-field out-of-scope"
        *ngFor="let field of outOfScopeAddrFields; index as i"
        [tooltipContent]="field.error"
        [tooltipDelay]="250"
        [tooltipInteractive]="false"
        tooltipPlacement="bottom"
        capraTooltip
      >
        <capra-icon icon="icon-close" (click)="removeOutOfScopeField(i)"></capra-icon>
        <capra-icon icon="icon-warning"></capra-icon>
        <div class="name">
          {{ field.displayName }}
        </div>
      </div>
      <div
        class="sd-field"
        *ngFor="let field of addrFields; trackBy: trackByAlias"
        (dndStart)="onDragStart(field, addrFields)"
        (dndEnd)="onDragEnd()"
        dndDraggingClass="dragging"
        dndEffectAllowed="move"
        dndDraggable
      >
        <capra-icon icon="icon-drag-handle"></capra-icon>
        <div class="name">
          {{ field.displayFormula }}
        </div>
      </div>
    </div>
    <div class="sd-divider"></div>
    <div class="sd-label">Partitioning</div>
    <div
      class="sd-fields"
      [class.empty]="!partFields.length"
      (dndDrop)="onDrop($event.index, partFields)"
      dndEffectAllowed="move"
      dndDropzone
    >
      <div class="sd-field-placeholder" dndPlaceholderRef></div>
      <div
        class="sd-field"
        *ngFor="let field of partFields; trackBy: trackByAlias"
        (dndStart)="onDragStart(field, partFields)"
        (dndEnd)="onDragEnd()"
        dndDraggingClass="dragging"
        dndEffectAllowed="move"
        dndDraggable
      >
        <ng-template #dragHandle>
          <capra-icon icon="icon-drag-handle"></capra-icon>
        </ng-template>
        <capra-icon
          icon="icon-warning"
          *ngIf="hasSortWarning(field); else dragHandle"
          [tooltipContent]="sortWarningTooltipContent"
          [tooltipDelay]="250"
          [tooltipInteractive]="false"
          tooltipPlacement="bottom"
          capraTooltip
        ></capra-icon>
        <div class="name">
          {{ field.displayFormula }}
        </div>
      </div>
    </div>
  </div>
  <!--
    Description of the computation
    -->
  <div class="frame-desc" *ngIf="outOfScopeAddrFields.length; else frameDesc">
    The table calculation is missing a required field, and it cannot be applied to the visualization.
  </div>
  <ng-template #frameDesc>
    <div class="frame-desc" *ngIf="hasDimensions">
      <ng-container *ngIf="addrFields.length"
        >Calculate {{ partFields.length ? '' : 'once' }} based on the values in
        <span>addressing fields</span></ng-container
      ><ng-container *ngIf="partFields.length"
        >{{ addrFields.length ? ', and reapply' : 'Reapply' }} the calculation within
        <span>partitioning fields</span></ng-container
      >.
    </div>
  </ng-template>
  <div class="learn-more-text">
    <a
      [attr.href]="helpDocs.links['https://mode.com/help/articles/visual-explorer#table-calculation-settings']"
      target="_blank"
      rel="noopener"
      >Learn more</a
    >
    about table calculations
  </div>
</div>
<div mat-dialog-actions>
  <div>
    <capra-button
      text="Reset"
      variant="secondary"
      color="neutral"
      [disabled]="isResetDisabled"
      (clicked)="reset()"
    ></capra-button>
  </div>
  <div>
    <capra-button text="Apply" variant="secondary" color="neutral" (clicked)="apply(false)"></capra-button>
    <capra-button text="Apply and close" color="default" (clicked)="apply(true)"></capra-button>
  </div>
</div>
